import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=0f999009&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"
import style0 from "./Letter.vue?vue&type=style&index=0&id=0f999009&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f999009",
  null
  
)

export default component.exports